var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
var Background = /** @class */ (function (_super) {
    __extends(Background, _super);
    function Background() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Background.prototype, "position", {
        get: function () { return (this.horizontalPosition || '') + " " + (this.verticalPosition || ''); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Background.prototype, "backgroundStyleObj", {
        get: function () { return parseStyle(this.backgroundStyle); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Background.prototype, "overlayStyleObj", {
        get: function () { return parseStyle(this.overlayStyle); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Background.prototype, "gradient", {
        get: function () {
            var key = "gradient:";
            var effect = (this.effect || "").toLowerCase();
            return effect.indexOf("gradient:") === 0
                ? "linear-gradient(to " + effect.substring(key.length).trim() + ", " + (this.color || 'transparent') + ", " + (this.secondaryColor || 'transparent') + ")"
                : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Background.prototype, "image", {
        get: function () {
            return this.imageUrl
                ? "url('" + this.imageUrl + "')"
                : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Background.prototype, "backgroundImage", {
        get: function () {
            return (this.image && this.gradient && !this.imageEffect ? this.image + ", " + this.gradient : null)
                || this.image
                || (!this.imageEffect ? this.gradient : null);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Background.prototype, "backgroundColor", {
        get: function () {
            return !this.backgroundImage || this.image
                ? this.color
                : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Background.prototype, "overlayBackgroundImage", {
        get: function () {
            return (this.imageEffect ? this.gradient : null);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Prop({ type: Boolean, default: false })
    ], Background.prototype, "page", void 0);
    __decorate([
        Prop({ type: String })
    ], Background.prototype, "color", void 0);
    __decorate([
        Prop({ type: String })
    ], Background.prototype, "secondaryColor", void 0);
    __decorate([
        Prop({ type: String })
    ], Background.prototype, "imageUrl", void 0);
    __decorate([
        Prop({ type: String })
    ], Background.prototype, "size", void 0);
    __decorate([
        Prop({ type: String })
    ], Background.prototype, "horizontalPosition", void 0);
    __decorate([
        Prop({ type: String })
    ], Background.prototype, "verticalPosition", void 0);
    __decorate([
        Prop({ type: String })
    ], Background.prototype, "effect", void 0);
    __decorate([
        Prop({ type: Boolean, default: false })
    ], Background.prototype, "imageEffect", void 0);
    __decorate([
        Prop({ type: String })
    ], Background.prototype, "backgroundStyle", void 0);
    __decorate([
        Prop({ type: String })
    ], Background.prototype, "overlayStyle", void 0);
    Background = __decorate([
        Component({
            name: "Background"
        })
    ], Background);
    return Background;
}(Vue));
export default Background;
;
function parseStyle(style) {
    if (!style)
        return null;
    var obj = {};
    style.split(';')
        .map(function (p) { return p.trim(); })
        .map(function (p) { return p.split(':'); })
        .map(function (p) { return ({ key: p[0], value: p.slice(1).join(':') }); })
        .forEach(function (p) { return obj[p.key] = p.value; });
    return obj;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/Background.vue
// module id = 66
// module chunks = 0 1 5 7 8 9 11